
import PageState from "./state"
import mutations from "./mutations"
import {getModule} from '@/store/store'
let APIS = {
  getStoreSearchCriteria: `get /apis/tts-web-api/v1/storeSpeakerV2/getStoreSearchCriteria`, // 发音人分类
  // getUserSpeakerByType: 'get /apis/tts-web-api/v1/mediaPlayer/getUserSpeakerByType', // 获取用户相关发音人类型[已购/常用/我的/收藏] 或者该接口不调用,直接查询sort =3
  // getSpeakerBySearch:`get /apis/tts-web-api/v4/speaker/search`,//根据关键字查找发音人
  getSpeakerBySearch:`get /apis/tts-web-api/speaker/store/search`,//新查询接口
  collectSave:`post /apis/tts-web-api/speaker/collect/save`,//收藏声音
  getCloneList:`get /apis/tts-web-api/v2/voice/clone/list`//获取克隆列表
}
export default {
  ...getModule({
    state:new PageState(),
    mutations,
    actions:{},
    APIS,
    name:"searchSpeakerPage"
  })
}